export const ACTA = 'ACTA DE AUDIENCIA';